export default __webpack_public_path__ + "assembly6e56495.png";